import { createAction } from 'redux-actions';
import { pluck } from 'ramda';
import { onAuthStateChanged, setPersistence, signInWithEmailAndPassword, signOut } from "firebase/auth";

import { auth, AUTH_PERSISTANCE_LOCAL } from '../firebase';

const AUTHENTICATION_CHECK_SESSION_REQUEST = 'AUTHENTICATION_CHECK_SESSION_REQUEST';
const AUTHENTICATION_CHECK_SESSION_SUCCESS = 'AUTHENTICATION_CHECK_SESSION_SUCCESS';

const AUTHENTICATION_LOGIN_REQUEST = 'AUTHENTICATION_LOGIN_REQUEST';
const AUTHENTICATION_LOGIN_SUCCESS = 'AUTHENTICATION_LOGIN_SUCCESS';
const AUTHENTICATION_LOGIN_FAILED = 'AUTHENTICATION_LOGIN_FAILED';

const AUTHENTICATION_LOGOUT_REQUEST = 'AUTHENTICATION_LOGOUT_REQUEST';
const AUTHENTICATION_LOGOUT_SUCCESS = 'AUTHENTICATION_LOGOUT_SUCCESS';
const AUTHENTICATION_LOGOUT_FAILED = 'AUTHENTICATION_LOGOUT_FAILED';

const checkSessionRequest = createAction(AUTHENTICATION_CHECK_SESSION_REQUEST);
const checkSessionSuccess = createAction(AUTHENTICATION_CHECK_SESSION_SUCCESS);

const loginRequest = createAction(AUTHENTICATION_LOGIN_REQUEST);
const loginSuccess = createAction(AUTHENTICATION_LOGIN_SUCCESS);
const loginFailed = createAction(AUTHENTICATION_LOGIN_FAILED);

const logoutRequest = createAction(AUTHENTICATION_LOGOUT_REQUEST);
const logoutSuccess = createAction(AUTHENTICATION_LOGOUT_SUCCESS);
const logoutFailed = createAction(AUTHENTICATION_LOGOUT_FAILED);

function getUserFromCredential(credential) {
  const providers = pluck('providerId', credential.providerData || []);
  return {
    name: credential.displayName,
    email: credential.email,
    photoUrl: credential.photoURL,
    emailVerified: credential.emailVerified,
    uid: credential.uid,
    providers,
  };
}

export const checkSession = () => {
  return dispatch => {
    dispatch(checkSessionRequest());

    onAuthStateChanged(auth, userCredential => {
      const user = userCredential ? getUserFromCredential(userCredential) : null;
      dispatch(checkSessionSuccess({ user }));
    });
  };
};

export const login = (username, password) => {
  return dispatch => {
    dispatch(loginRequest());

    setPersistence(auth, AUTH_PERSISTANCE_LOCAL)
      .then(() => {
        signInWithEmailAndPassword(auth, username, password)
          .then(userCredential => {
            const user = getUserFromCredential(userCredential);
            dispatch(loginSuccess({ user }));
          })
          .catch(error => {
            dispatch(loginFailed({
              notie: { type: 'error', message: error.message },
            }));
          });
      });
  };
};

export const logout = () => {
  return dispatch => {
    dispatch(logoutRequest());

    signOut(auth)
      .then(() => {
        dispatch(logoutSuccess());
      })
      .catch(error => {
        dispatch(logoutFailed({
          notie: { type: 'error', message: error.message },
        }));
      });
  };
};

const actions = {
  AUTHENTICATION_CHECK_SESSION_REQUEST,
  AUTHENTICATION_CHECK_SESSION_SUCCESS,
  AUTHENTICATION_LOGIN_REQUEST,
  AUTHENTICATION_LOGIN_SUCCESS,
  AUTHENTICATION_LOGIN_FAILED,
  AUTHENTICATION_LOGOUT_REQUEST,
  AUTHENTICATION_LOGOUT_SUCCESS,
  AUTHENTICATION_LOGOUT_FAILED,
};

export { actions };